import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="max-w-5xl mx-auto px-6 py-20 text-slate-500">Checking authentication…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role && user.role !== "admin") return <Navigate to="/" replace />;
  // A provider who has no linked listing cannot access the provider dashboard yet.
  if (role === "provider" && user.role === "provider" && !user.provider_id && location.pathname.startsWith("/provider")) {
    return <Navigate to="/list-your-company?unlinked=1" replace />;
  }
  return children;
}
